const initState = {
    casoBordeEstado: false
  };
  
  export default initState;
  